export default {
  commitListLink: "commit list",
  forumsLink: "forums",
  transferTrackerLink: "transfer tracker"
};
